<template>
  <div class="padding">
    <h3 v-if="showTitle" class="mb-4 mt-0">
      Kortingsdetails
    </h3>

    <div v-if="!removeFlex" class="d-flex inputs_row ">
      <FormInput
        class="sm form-element"
        v-model="$v.name.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="name"

        id="name"
        label="Naam"
      />
      <FormSelect
        class="sm form-element middle"
        v-model="$v.type.$model"
        :ske="true"
        :vuelidate="$v"
        :options="typeOptions"
        fieldName="type"

        id="type"
        label="Type"
      />
      <FormInput
        class="sm form-element last"
        v-model="$v.minimum_price.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="minimum_price"

        id="minimum_price"
        label="Minimum prijs"
      />
    </div>
    <template v-else>
      <FormInput
        class="sm form-element"
        v-model="$v.name.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="name"

        id="name"
        label="Naam"
      />
      <FormSelect
        class="sm form-element"
        v-model="$v.type.$model"
        :ske="true"
        :vuelidate="$v"
        :options="typeOptions"
        fieldName="type"

        id="type"
        label="Type"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.minimum_price.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="minimum_price"

        id="minimum_price"
        label="Minimum prijs"
      />
    </template>

    <div v-if="!removeFlex" class="d-flex inputs_row ">
      <FormInput
        class="sm form-element"
        v-model="$v.simple_free_shipping.$model"
        :ske="true"
        :vuelidate="$v"
        type="number"
        fieldName="simple_free_shipping"

        id="simple_free_shipping"
        label="Eenvoudige gratis verzending"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.uses_per_customer.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        type="number"
        fieldName="uses_per_customer"

        id="uses_per_customer"
        label="Gebruik per klant"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.usage_limit.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        type="number"
        fieldName="usage_limit"

        id="usage_limit"
        label="Gebruikslimiet"
      />
    </div>
    <template v-else>
      <FormSelect
        class="sm form-element"
        v-model="$v.simple_free_shipping.$model"
        :ske="true"
        :vuelidate="$v"
        :options="typeOptions"
        fieldName="simple_free_shipping"

        id="simple_free_shipping"
        label="Eenvoudige gratis verzending"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.uses_per_customer.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="uses_per_customer"

        id="uses_per_customer"
        label="Gebruik per klant"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.usage_limit.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="usage_limit"

        id="usage_limit"
        label="Gebruikslimiet"
      />
    </template>

    <div v-if="!removeFlex" class="d-flex">
      <FormInput
        class="sm form-element"
        v-model="$v.discount_value.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="discount_value"

        id="discount_value"
        label="Waarde"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.couponCode.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="couponCode"

        id="couponCode"
        label="Coupon code"
      />
    </div>
    <template v-else>
      <FormInput
        class="sm form-element"
        v-model="$v.discount_value.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="discount_value"

        id="discount_value"
        label="Waarde"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.couponCode.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="couponCode"

        id="couponCode"
        label="Coupon code"
      />
    </template>
    <div v-if="!removeFlex" class="d-flex">
      <FormDatePicker
        class="sm form-element"
        v-model="$v.startDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="startDate"

        id="startDate"
        label="Begin datum"
      />
      <FormDatePicker
        class="sm form-element"
        v-model="$v.endDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="endDate"

        id="endDate"
        label="Einddatum"
      />
    </div>
    <template v-else>
      <FormDatePicker
        class="sm form-element"
        v-model="$v.startDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="startDate"

        id="startDate"
        label="Begin datum"
      />
      <FormDatePicker
        :class="{'sm form-element': !removeFlex}"
        v-model="$v.endDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="endDate"

        id="endDate"
        label="Einddatum"
      />
    </template>

    <FormCheckbox
      :value="!!$v.apply_to_shipping.$model"

      class="form-checkbox"
      :updateOnClick="false"
      @click.native="$v.apply_to_shipping.$model = !$v.apply_to_shipping.$model"
    >
      Gelden voor verzending
    </FormCheckbox>
  </div>
</template>

<script>

import FormInput from "../../../../components/Inputs/FormInput.vue"
import FormCheckbox from "../../../../components/Inputs/FormCheckbox.vue";
import FormSelect from "../../../../components/Inputs/FormSelect.vue"
import FormDatePicker from "../../../../components/Inputs/FormDatePicker.vue"

import setupForm from "../../../../mixins/setupForm"
import { required } from "vuelidate/lib/validators"
import mom from "moment"

const decimal = value => (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false

const fields = ["name", "discount_value", "startDate", "endDate", "type", "couponCode", "minimum_price", "apply_to_shipping", "simple_free_shipping", "uses_per_customer", "usage_limit"]

export default setupForm(fields, {
  components: {
    FormCheckbox,
    FormDatePicker,
    FormInput,
    FormSelect,
  },
  props: {
    removeFlex: Boolean,
    showTitle: Boolean,
  },
  validations: {
    name: {
      required,
    },
    discount_value: {
      required,
      decimal,
    },
    startDate: {
      required,
    },
    endDate: {
      required,
    },
  },
  computed: {
    typeOptions() {
      return [
        {
          value: "price",
          str: "Kortingsprijs product",
        },
        {
          value: "percentage",
          str: "Kortingspercentage product",
        },
        {
          value: "price_cart",
          str: "Kortingsprijs winkelwagen",
        },
        {
          value: "percentage_cart",
          str: "Kortingspercentage winkelwagen",
        },
      ]
    },
  },
  mounted () {
    if(this.$v.startDate.$model === '') {
      this.$v.startDate.$model = null
    }
    if(this.$v.endDate.$model === '') {
      this.$v.endDate.$model = null
    }
  },
  watch: {
    '$v.startDate.$model'(val) {
      if(val === '') {
        this.$v.startDate.$model = null
      } else {
        if(val && mom(val).format("YYYY-MM-DD") == 'Invalid date') {
          let subDate = val.substring(0, 10);
          let splitDate = subDate.split('-')
          let newDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
          this.$v.startDate.$model = newDate
        }
      }
    },
    '$v.endDate.$model'(val) {
      if(val === '') {
        this.$v.endDate.$model = null
      } else {
        if(val && mom(val).format("YYYY-MM-DD") == 'Invalid date') {
          let subDate = val.substring(0, 10);
          let splitDate = subDate.split('-')
          let newDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
          this.$v.endDate.$model = newDate
        }
      }
    },
  },
  methods: {
    date() {
      console.log(this.$v.startDate.$model, "start date")
    console.log(this.$v.endDate.$model, "end date")
    }
  }
})

</script>

<style scoped src="@/assets/css/form.css"></style>
